import React, { useEffect, useState } from "react";
import { countdownParts, fmtReleaseDate } from "@/lib/release";

const Cell = ({ value, label }) => (
  <div className="text-center">
    <div className="font-display foil-text" style={{ fontSize: "clamp(1.6rem,3vw,2.4rem)", lineHeight: 1 }}>
      {String(value).padStart(2, "0")}
    </div>
    <div className="font-caps text-ash mt-1" style={{ fontSize: ".5rem" }}>{label}</div>
  </div>
);

/** Live countdown. Renders in the visitor's local time; Phoenix date shown beneath. */
export const CountdownTimer = ({ releaseAt }) => {
  const [parts, setParts] = useState(() => countdownParts(releaseAt));
  useEffect(() => {
    const t = setInterval(() => setParts(countdownParts(releaseAt)), 1000);
    return () => clearInterval(t);
  }, [releaseAt]);

  if (!parts) return null;
  const label = `Releases ${fmtReleaseDate(releaseAt, { weekday: true })}`;
  if (parts.done) {
    return <p className="font-caps text-gold" style={{ fontSize: ".7rem" }}>Out now</p>;
  }
  return (
    <div>
      <div className="flex gap-4 justify-start" aria-hidden="true">
        <Cell value={parts.days} label="Days" />
        <Cell value={parts.hours} label="Hrs" />
        <Cell value={parts.minutes} label="Min" />
        <Cell value={parts.seconds} label="Sec" />
      </div>
      <p className="font-caps text-gold mt-3" style={{ fontSize: ".58rem" }} aria-live="off">{label}</p>
    </div>
  );
};
